import {
  LAYOUT_SCROLL_ID,
  PAGE_SCROLL_ID,
} from '@backrs_ui/grow-ui/src/components/PageShell/pageShell.layout';

// The window never scrolls on these pages; a nested layout box does, and which one depends
// on the layout — so reset both. Scrolling a box that cannot scroll is a no-op.
const SCROLLPORT_IDS = [PAGE_SCROLL_ID, LAYOUT_SCROLL_ID];

const scrollBehavior = (): ScrollBehavior =>
  window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

export const scrollPageToTop = (): void => {
  const behavior = scrollBehavior();

  SCROLLPORT_IDS.forEach((id) => {
    document.getElementById(id)?.scrollTo({ top: 0, behavior });
  });
};

/** Least scrolling that brings `element` into view; a no-op when it is already fully visible. */
export const revealElement = (
  element: HTMLElement | null,
  block: ScrollLogicalPosition = 'nearest',
): void => {
  element?.scrollIntoView({ behavior: scrollBehavior(), block });
};
